//AboutMe.js
import React from 'react'
import { Text, View } from 'react-native'
import styles from './Styles.js'

const border = 1;

const AboutMe = () => {
  return (
    <View>
      <Text style={styles.titleText}>About me</Text>
      <Text style={styles.baseText}>Marcio Adriano Seno has been a private tutor focused on teenage students since 1995, he lives in Alphaville, Barueri SP Brazil.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>He taught young people from important business families and executives preparing their students for university life.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>He studied courses at the University of São Paulo and graduated in Mathematics and Business Management.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>Masters mathematics, physics and chemistry among other subjects in elementary and high school.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>Believes in constructivism and emphasizes performing tasks.</Text>
      <Text> </Text>
      <Text style={styles.baseText}>He is a hobbyist mobile app developer at React Native.</Text>
      <Text> </Text>
      <Text> </Text>
    </View>
  )
};
export default AboutMe;
